<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row">
      <div class="col-12">
        <h1>Mentions légales</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-4">
        Conformément à l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance
        dans l'économie numérique (LCEN), les informations suivantes sont portées à la
        connaissance des utilisateurs du site www.lettrecomptetriple.org.
      </div>

      <div class="col-12 mt-4">
        <h4>Présentation du site</h4>
        Lettre Compte Triple a pour objectif de promouvoir le Scrabble francophone
        en proposant des solutions aux clubs de Scrabble dans l'organisation de tournois.<br />
        L'inscription et l'accès aux parties sont gratuits. Les joueurs qui le souhaitent
        peuvent soutenir le site en devenant adhérents : l'adhésion, d'un montant libre
        et valable un an, participe aux frais de fonctionnement et supprime l'affichage
        des publicités.
      </div>

      <div class="col-12 mt-4">
        <h4>Éditeur du site</h4>
        www.lettrecomptetriple.org est édité par GOURIO CONSULTING, société par actions
        simplifiée au capital social de 2 000 €, immatriculée au Registre du Commerce et
        des Sociétés de Bobigny sous le numéro 892 585 225, représentée par
        M. Sylvain GOURIO agissant et ayant les pouvoirs nécessaires en tant que président.<br />
        14 rue Auber<br />
        75009 Paris<br />
        E-mail : <a href="mailto:sylvain@lettrecomptetriple.org">sylvain@lettrecomptetriple.org</a>
      </div>

      <div class="col-12 mt-4">
        <h4>Directeur de la publication</h4>
        Sylvain Gourio
      </div>

      <div class="col-12 mt-4">
        <h4>Hébergement</h4>
        Le site est hébergé par Amazon Web Services EMEA SARL<br />
        38 avenue John F. Kennedy<br />
        L-1855 Luxembourg<br />
        <a href="https://aws.amazon.com" target="_blank" rel="noopener">aws.amazon.com</a><br />
        Les données sont stockées dans la région AWS Europe (Irlande).
      </div>

      <div class="col-12 mt-4">
        <h4>Propriété intellectuelle</h4>
        L'ensemble des éléments du site (textes, graphismes, logos, logiciels, mise en page)
        est la propriété de GOURIO CONSULTING ou fait l'objet d'une autorisation
        d'utilisation. Toute reproduction, représentation ou diffusion, totale ou partielle,
        sans autorisation écrite préalable est interdite.<br />
        Scrabble® est une marque déposée appartenant à ses propriétaires respectifs.
        Lettre Compte Triple n'est ni affilié, ni soutenu par ces derniers.
      </div>

      <div class="col-12 mt-4">
        <h4>Contenus publiés par les joueurs</h4>
        Les joueurs sont responsables des contenus qu'ils publient sur le site (pseudo,
        photo de profil, messages du chat). Tout contenu illicite, injurieux ou contraire
        aux bonnes mœurs est interdit. Il peut être signalé à
        <a href="mailto:sylvain@lettrecomptetriple.org">sylvain@lettrecomptetriple.org</a>
        et sera supprimé dans les meilleurs délais ; le compte de son auteur pourra
        être suspendu.
      </div>

      <div class="col-12 mt-4">
        <h4>Responsabilité</h4>
        L'éditeur s'efforce d'assurer l'exactitude des informations et la disponibilité
        du site, sans pouvoir le garantir. Il ne saurait être tenu responsable d'une
        interruption du service, d'un dysfonctionnement ou du contenu des sites tiers
        vers lesquels des liens renvoient.
      </div>

      <div class="col-12 mt-4">
        <h4>Données personnelles et cookies</h4>
        Le traitement de vos données personnelles et l'utilisation des cookies sont
        décrits dans la
        <router-link to="/confidentialite">politique de confidentialité</router-link>.
      </div>

      <div class="col-12 mt-4 mb-4">
        <h4>Droit applicable</h4>
        Les présentes mentions légales sont soumises au droit français.
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import LoggedUser from './LoggedUser.vue';
import BottomNav from './BottomNav.vue';

export default {
  name: 'MentionsLegales',
  components: { LoggedUser, BottomNav },
};
</script>

<style scoped>

</style>
